import React, { useEffect } from 'react';
import Navigation from './components/Navigation/Navigation';
import Hero from './components/Hero/Hero';
import Stats from './components/Stats/Stats';
import Expertise from './components/Expertise/Expertise';
import Experience from './components/Experience/Experience';
import Skills from './components/Skills/Skills';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import { Analytics } from '@vercel/analytics/react';
import './App.css';  // 👈 REMOVE crisp-sdk-web import

function App() {
  useEffect(() => {
    // ✅ CORRECT Crisp setup (NO SDK needed)
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = '47f1292c-d650-466b-830e-8a2da71bd02b';
    
    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    document.head.appendChild(script);
    
    // ✅ FIXED: No disconnect() - just cleanup
    return () => {
      if (window.$crisp) {
        window.$crisp.push(['do', 'chat:disconnect']);
      }
    };
  }, []);

  return (
    <div className="App">
      <Navigation />
      <Hero />
      <Stats />
      <Expertise />
      <Experience />
      <Skills />
      <Contact />
      <Footer />
      <Analytics /> 
    </div>
  );
}

export default App;
